import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { RouteHandlerService } from './route-handler.service';

@Injectable({
  providedIn: 'root'
})
export class CommonDataPassService {
  private routeHandler = inject(RouteHandlerService)
  constructor() { }

    //open custom toastr
    private customToastr = new Subject<any>();
    customToastr$ = this.customToastr.asObservable();
    openCustomToastr(data: any) {
      this.customToastr.next(data);
    }

     //open clear cart info toastr
    private clearCartInfo = new Subject<any>();
    clearCartInfo$ = this.clearCartInfo.asObservable();
    openClearCartInfo(data: any) {
      this.clearCartInfo.next(data);
    }

     //open cancel payment modal
    private cancelPaymentModal = new Subject<any>();
    cancelPaymentModal$ = this.cancelPaymentModal.asObservable();
    openCancelPaymentModal(data: any) {
      this.cancelPaymentModal.next(data);
    }

    routeTo(slug:string,route:string,queryparam?:any){
      this.routeHandler.routeTo(slug, route, queryparam);
    }

  _routeLoading = new BehaviorSubject<boolean>(true);
  routeLoading$ = this._routeLoading.asObservable();
  hide() {
    this._routeLoading.next(false);
  }
  show() {
    this._routeLoading.next(true);
  }

  isOrderLoading= new BehaviorSubject<boolean>(false);

  isFromDifferentDomain(): boolean {
    return this.routeHandler.isFromDifferentDomain();
  }

  private readonly returnUrlStorageKey = 'paymentReturnUrl';
  returnUrl: null | string = null

  setReturnUrl(url: string | null | undefined): void {
    if (!url) {
      return;
    }
    this.returnUrl = url;
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem(this.returnUrlStorageKey, url);
    }
  }

  getReturnUrl(): string | null {
    if (this.returnUrl) {
      return this.returnUrl;
    }
    if (typeof sessionStorage !== 'undefined') {
      return sessionStorage.getItem(this.returnUrlStorageKey);
    }
    return null;
  }

  clearReturnUrl(): void {
    this.returnUrl = null;
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.removeItem(this.returnUrlStorageKey);
    }
  }

  routeToExternalUrl(extendedUrl?: string): void {
    const returnUrl = this.getReturnUrl();
    if (!returnUrl) {
      return;
    }
    window.location.href = extendedUrl ? returnUrl + extendedUrl : returnUrl;
    this.clearReturnUrl();
  }
}
